import {API_URL, apiPost} from '../api'

export const postEditComment = async (id: string, content: string = '') => {
    return await apiPost(API_URL, 'admin/comment_edit', {id: id, content: content})
}
